(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ai_gen_block_free_audit"] && !Shopify.designMode) return;
  try {
    (function() {
    const uid = '{{ uid }}';
    const items = document.querySelectorAll('.fa-faq-item-' + uid);
    items.forEach(function(item) {
      const btn = item.querySelector('.fa-faq-q-' + uid);
      btn.addEventListener('click', function() {
        const isOpen = item.classList.contains('is-open');
        // Close all
        items.forEach(function(el) { el.classList.remove('is-open'); });
        // Toggle current
        if (!isOpen) item.classList.add('is-open');
      });
    });

    // Smooth scroll for anchor links
    document.querySelectorAll('a[href="#fa-form-anchor-' + uid + '"]').forEach(function(link) {
      link.addEventListener('click', function(e) {
        e.preventDefault();
        var target = document.getElementById('fa-form-anchor-' + uid);
        if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
